<section class="bloghero">
  <h1 class="bloghero__page-title">{{ pageTitle }}</h1>

  <div class="bloghero__content">
    <div class="bloghero__image-panel">
      @if (videoSrc) {
      <video #heroVideo
             class="bloghero__image"
             [src]="videoSrc"
             [poster]="imageSrc"
             [attr.aria-label]="title + ' testimonial video'"
             muted
             autoplay
             loop
             playsinline
             preload="auto"
             controlslist="nodownload noplaybackrate noremoteplayback"
             disablePictureInPicture>
      </video>
      } @else {
      <img class="bloghero__image"
           [src]="imageSrc"
           [alt]="imageAlt" />
      }

      @if (posterCaption) {
      <p class="bloghero__caption">{{ posterCaption }}</p>
      }
    </div>

    <div class="bloghero__details">
      <h2 class="bloghero__title">{{ title }}</h2>

      @if (quote) {
      <blockquote class="bloghero__quote">
        “{{ quote }}”
      </blockquote>
      }

      <p class="bloghero__text">
        {{ text }}
      </p>

      @if (author || role || date) {
      <p class="bloghero__meta">
        @if (author) {
        <span class="bloghero__meta-item bloghero__meta-item--author">{{ author }}</span>
        }
        @if (role) {
        <span class="bloghero__meta-item">{{ role }}</span>
        }
        @if (date) {
        <span class="bloghero__meta-item">{{ date }}</span>
        }
      </p>
      }

      <div class="bloghero__actions">
        @if (readMoreLink) {
        <a class="bloghero__button bloghero__button--secondary" [routerLink]="readMoreLink">{{ readMoreLabel }}</a>
        }

        @if (contactLink) {
        <a class="bloghero__button bloghero__button--primary" [routerLink]="contactLink">{{ contactLabel }}</a>
        }

        @if (qaLink) {
        <a class="bloghero__button bloghero__button--secondary" [routerLink]="qaLink">{{ qaLabel }}</a>
        }
      </div>
    </div>
  </div>
</section>
